import { fetchApi } from "./api";

export type TemplateInput = {
  slug: string;
  name: string;
  description?: string | null;
  hero_image_path?: string | null;
  hero_kicker?: string | null;
  hero_title?: string | null;
  hero_subtitle?: string | null;
  body_md?: string;
  seo_title?: string | null;
  seo_description?: string | null;
  is_published?: boolean;
};

// Public: list site templates.
export const listTemplates = () =>
  fetchApi<any[]>("content", "listTemplates", {}, { auth: false });

// Admin only: every template, unpublished ones included. Feeds the
// Admin > Templates list so an unpublished page can be switched back on.
export const listAllTemplates = () => fetchApi<any[]>("content", "listAllTemplates");

// Public: fetch a single template by slug.
export const getTemplateBySlug = (opts: { data: { slug: string } }) =>
  fetchApi<any>("content", "getTemplateBySlug", opts.data, { auth: false });

export const createTemplate = (opts: { data: TemplateInput }) =>
  fetchApi<any>("content", "createTemplate", opts.data);

export const updateTemplate = (opts: { data: TemplateInput & { id: string } }) =>
  fetchApi<any>("content", "updateTemplate", opts.data);

export const deleteTemplate = (opts: { data: { id: string } }) =>
  fetchApi<{ ok: true }>("content", "deleteTemplate", opts.data);
